import { Injectable, OnDestroy, signal, inject } from '@angular/core';

import { Loggable } from 'app/utils/logging/loggable';
import { BrowserService } from './browser.service';

export const STARTING_POINT_KEY = 'showStartingPointAtMaxModal';

@Injectable({
  providedIn: 'root',
})

//Service to handle fullscreen mode in the application in general
export class FullScreenService extends Loggable implements OnDestroy {
  private browserService = inject(BrowserService);

  public readonly isMobileFullscreen = signal<boolean>(false);
  public readonly isFullScreen = signal<boolean>(false);

  private handleFullscreenChangeBound: () => void;

  public constructor() {
    super();
    this.setDisplayName('FullScreenService');
    this.handleFullscreenChangeBound = this.handleFullscreenChange.bind(this); // Store the bound handler
    this.initListeners();
  }

  private initListeners(): void {
    document.addEventListener('fullscreenchange', this.handleFullscreenChangeBound);
    this.handleFullscreenChange();
  }

  private handleFullscreenChange() {
    this.isFullScreen.set(!!document.fullscreenElement);
    this.isMobileFullscreen.set(!!document.fullscreenElement && this.browserService.isAndroidDevice());
  }

  public ngOnDestroy(): void {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChangeBound); // Use the stored handler
  }
}
